<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-card flat>
        <v-card-text class="pb-0">
          <div class="rowinfo mb-4">
            <v-select
              v-model="data.pdfSelector.layout"
              :items="layoutOptions"
              item-text="text"
              item-value="value"
              :label="$t('pdf_gallery.display_mode')"
              outlined
              dense
              hide-details
              class="contentinfo"
              prepend-inner-icon="mdi-view-dashboard-outline"
            ></v-select>
            <help-info
              :element-name="`${serviceName}-${componentName}-layout`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('pdf_gallery.display_mode_label')"
            />
          </div>
        </v-card-text>
        <v-expansion-panels class="pa-2">
          <v-expansion-panel
            v-for="(salon, index) in gallery"
            :key="index"
            class="mt-2 rounded-lg"
          >
            <v-expansion-panel-header @click.stop.prevent="activeGalleryIndex = index">
              <div class="d-flex align-center" style="width: 100%">
                <div class="d-flex flex-column justify-center align-center ml-3">
                  <v-btn
                    icon
                    x-small
                    @click.stop="moveGalleryUp(index)"
                    :disabled="index === 0"
                  >
                    <v-icon>mdi-chevron-up</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    x-small
                    @click.stop.prevent="moveGalleryDown(index)"
                    :disabled="index === gallery.length - 1"
                  >
                    <v-icon>mdi-chevron-down</v-icon>
                  </v-btn>
                </div>

                <div class="flex-grow-1 d-flex align-center">
                  <span
                    v-if="index !== editGaleryName"
                    class="font-weight-bold text-subtitle-1"
                  >
                    {{ salon.name }}
                  </span>

                  <div class="rowinfo w-100" v-if="index === editGaleryName">
                    <v-text-field
                      hide-details
                      :label="$t('pdf_gallery.gallery_name')"
                      v-model="salon.name"
                      @click.stop.prevent
                      dense
                      append-icon="check"
                      @click:append.stop="editGaleryName = -1"
                      outlined
                      class="my-2 contentinfo"
                    >
                    </v-text-field>
                    <help-info
                      :element-name="`${serviceName}-${componentName}-salon-name`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      :label="$t('pdf_gallery.gallery_name')"
                    />
                  </div>
                  <v-btn
                    icon
                    small
                    @click.stop.prevent="editGaleryName = index"
                    v-if="index !== editGaleryName"
                  >
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>

                  <help-info
                    class="buttoninfo mx-1"
                    v-if="index !== editGaleryName && index === -1"
                    :element-name="`${serviceName}-${componentName}-salon-name`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    :label="$t('pdf_gallery.selected_gallery')"
                  />
                </div>

                <div class="d-flex align-center mr-auto">
                  <v-btn
                    icon
                    @click.stop.prevent="gallery.splice(index, 1)"
                    max-width="36"
                    v-if="gallery.length > 1"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </div>
              </div>
            </v-expansion-panel-header>

            <v-expansion-panel-content class="mt-4">
              <div class="py-0 my-0">
                <div class="d-flex align-center">
                  <div
                    class="rowinfo"
                    style="max-width: 100% !important; width: 100% !important"
                  >
                    <v-btn
                      class="btn-get-code rounded-lg d-flex contentinfo"
                      @click.stop.prevent="dialog = true"
                      outlined
                      block
                    >
                      <v-icon>mdi-plus</v-icon>{{ $t('pdf_gallery.add_file') }}
                    </v-btn>
                    <help-info
                      v-if="index !== editGaleryName"
                      :element-name="`${serviceName}-${componentName}-gallery-pdf`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      :label="$t('pdf_gallery.pdf_gallery_label')"
                    />
                  </div>
                </div>

                <custom-popup
                  v-model="dialog"
                  :cons="{ title: $t('pdf_gallery.select_file'), icon: 'file' }"
                  max-width="960"
                  id="gallery"
                  reloadable
                  eager
                  @reload="getFiles()"
                >
                  <template v-slot:helpinfo>
                    <help-info
                      :element-name="`${serviceName}-${componentName}-tab-gallery-pdf`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      :label="$t('pdf_gallery.add_file')"
                    />
                  </template>
                  <v-card
                    :loading="loading || defLoading"
                    flat
                    min-height="300"
                    style="overscroll-behavior: contain"
                  >
                    <custom-tabs
                      v-model="tabs"
                      :tabItems="tabItems"
                      :windowItems="tabItems"
                      :tabProps="{ color: 'primary' }"
                      :tabsItemsAttrs="{ color: 'primary' }"
                      show-arrows
                      grow
                    >
                      <template v-slot:tab="{ tab }">
                        <v-icon right>{{ tab.icon }}</v-icon>
                        <span class="font-weight-bold">{{ tab.text }}</span>
                        <help-info
                          :element-name="`${serviceName}-${componentName}-${tab.value}`"
                          :service-name="serviceName"
                          :help-data="helpData"
                          class="buttoninfo"
                          :label="tab.text"
                        />
                      </template>
                      <template v-slot:item="{ item }">
                        <div v-if="item.id === 2">
                          <v-card class="p-8">
                            <div class="rowinfo">
                              <v-text-field
                                hide-details
                                :label="$t('pdf_gallery.title')"
                                v-model="manualImage.title"
                                dense
                                outlined
                                class="my-2"
                              />
                              <help-info
                                :element-name="`${serviceName}-${componentName}-manualImage-title`"
                                :service-name="serviceName"
                                :help-data="helpData"
                                class="buttoninfo"
                                :label="$t('pdf_gallery.title')"
                              />
                            </div>
                            <div class="rowinfo">
                              <v-text-field
                                hide-details
                                :label="$t('pdf_gallery.pdf_url')"
                                v-model="manualImage.link"
                                dense
                                outlined
                                class="my-2"
                              />
                              <help-info
                                :element-name="`${serviceName}-${componentName}-manualImage-link`"
                                :service-name="serviceName"
                                :help-data="helpData"
                                class="buttoninfo"
                                :label="$t('pdf_gallery.pdf_url')"
                              />
                            </div>
                            <div class="rowinfo">
                              <v-textarea
                                maxLength="250"
                                hide-details
                                :label="$t('pdf_gallery.description')"
                                rows="5"
                                v-model="manualImage.description"
                                dense
                                outlined
                                class="my-2 contentinfo"
                              />
                              <help-info
                                :element-name="`${serviceName}-${componentName}-manualImage-description`"
                                :service-name="serviceName"
                                :help-data="helpData"
                                class="buttoninfo"
                                :label="$t('pdf_gallery.description')"
                              />
                            </div>

                            <v-card-actions>
                              <div
                                class="rowinfo"
                                style="width: 100% !important"
                              >
                                <v-btn
                                  @click.stop.prevent="addImageManual(salon)"
                                  class="btn-get-code rounded-lg ms-auto px-8 contentinfo"
                                  :disabled="!manualImage.title || !manualImage.link"
                                ><v-icon small>mdi-plus</v-icon>
                                  {{ $t('pdf_gallery.add_button') }}
                                </v-btn>
                                <help-info
                                  :element-name="`${serviceName}-${componentName}-manualImage-addImage`"
                                  :service-name="serviceName"
                                  :help-data="helpData"
                                  class="buttoninfo"
                                  :label="$t('pdf_gallery.add_button')"
                                />
                              </div>
                            </v-card-actions>
                          </v-card>
                        </div>
                        <div v-if="item.id === 1">
                          <v-card>
                            <v-tabs color="deep-purple accent-4" light>
                            <v-tab>{{ $t('pdf_gallery.all') }}</v-tab>
                              <v-tab-item>
                                <v-container fluid>
                                  <v-row class="p-3">
                                    <v-col
                                      v-for="image in file"
                                      :key="image.id"
                                      cols="12"
                                      md="3"
                                      lg="2"
                                      class="p-2"
                                      @click.stop.prevent="select(salon, image)"
                                    >
                                     <v-card
                                          outlined
                                          class="d-flex flex-column file-card"
                                          :class="{ selected: image.selected }"
                                          style="position: relative; overflow: hidden; border-radius: 12px; cursor: pointer;"
                                          height="180"
                                          @click.stop.prevent="select(salon, image)"
                                        >
                                         <v-img
                                            :src="image.url || getFileIcon(image.full_path || image.path)"
                                            height="100%"
                                            width="100%"
                                            cover
                                          >
                                            <template v-slot:placeholder>
                                              <div class="d-flex justify-center align-center fill-height w-100 grey lighten-4">
                                                <v-icon size="64" color="grey lighten-1">mdi-file-document-outline</v-icon>
                                              </div>
                                            </template>
                                            
                                            <template v-slot:default>
                                              <div style="position: absolute; top: 4px; right: 4px; z-index: 10;">
                                                <v-checkbox
                                                  v-model="image.selected"
                                                  color="success"
                                                  hide-details
                                                  class="ma-0 pa-0"
                                                  style="background: rgba(255, 255, 255, 0.8); border-radius: 4px;"
                                                  @click.stop.prevent="select(salon, image)"
                                                ></v-checkbox>
                                              </div>
                                              <div v-if="!image.url" class="d-flex justify-center align-center fill-height w-100 grey lighten-4">
                                                <v-icon size="80" color="grey">mdi-file-document-outline</v-icon>
                                              </div>
                                            </template>
                                          </v-img>

                                          <div 
                                            class="text-caption text-center pa-2 text-truncate" 
                                            style="position: absolute; bottom: 0; width: 100%; background-color: rgba(255, 255, 255, 0.9); backdrop-filter: blur(2px);"
                                            :title="`${image.title}.${image.path.split('.').pop()}`"
                                          >
                                            <span class="font-weight-bold" style="font-size: 13px;">
                                              {{ image.title }}.{{ image.path.split(".").pop() }}
                                            </span>
                                          </div>
                                        </v-card>

                                    </v-col>
                                  </v-row>
                                </v-container>
                              </v-tab-item>
                              <v-tab
                                v-for="(category, indexCategory) in fileCats"
                                :key="indexCategory"
                                >{{ category }}</v-tab
                              >
                              <v-tab-item
                                v-for="item in fileCats"
                                :key="item"
                                :data-id="item"
                              >
                                <v-container fluid>
                                  <v-row class="p-3">
                                    <v-col
                                      v-for="image in file.filter(
                                        (img) => img.category === item,
                                      )"
                                      :key="image.id"
                                      cols="12"
                                      md="3"
                                      lg="2"
                                      class="p-2"
                                      @click.stop.prevent="select(salon, image)"
                                    >
                                    <v-card
                                          outlined
                                          class="d-flex flex-column file-card"
                                          :class="{ selected: image.selected }"
                                          style="position: relative; overflow: hidden; border-radius: 12px; cursor: pointer;"
                                          height="180"
                                          @click.stop.prevent="select(salon, image)"
                                        >
                                         <v-img
                                            :src="image.url || getFileIcon(image.full_path || image.path)"
                                            height="100%"
                                            width="100%"
                                            cover
                                          >
                                            <template v-slot:placeholder>
                                              <div class="d-flex justify-center align-center fill-height w-100 grey lighten-4">
                                                <v-icon size="64" color="grey lighten-1">mdi-file-document-outline</v-icon>
                                              </div>
                                            </template>
                                            
                                            <template v-slot:default>
                                              <div style="position: absolute; top: 4px; right: 4px; z-index: 10;">
                                                <v-checkbox
                                                  v-model="image.selected"
                                                  color="success"
                                                  hide-details
                                                  class="ma-0 pa-0"
                                                  style="background: rgba(255, 255, 255, 0.8); border-radius: 4px;"
                                                  @click.stop.prevent="select(salon, image)"
                                                ></v-checkbox>
                                              </div>

                                              <div v-if="!image.url" class="d-flex justify-center align-center fill-height w-100 grey lighten-4">
                                                <v-icon size="80" color="grey">mdi-file-document-outline</v-icon>
                                              </div>
                                            </template>
                                          </v-img>


                                          <div 
                                            class="text-caption text-center pa-2 text-truncate" 
                                            style="position: absolute; bottom: 0; width: 100%; background-color: rgba(255, 255, 255, 0.9); backdrop-filter: blur(2px);"
                                            :title="`${image.title}.${image.path.split('.').pop()}`"
                                          >
                                            <span class="font-weight-bold" style="font-size: 13px;">
                                              {{ image.title }}.{{ image.path.split(".").pop() }}
                                            </span>
                                          </div>
                                        </v-card>
                                    </v-col>
                                  </v-row>
                                </v-container>
                              </v-tab-item>
                            </v-tabs>
                          </v-card>
                        </div>
                        <div v-if="item.id === 0">
                          <v-card class="pa-5" flat>
                            <slot name="default">
                              <detect-file-uploading_file
                                :loading="upLoading"
                                @change="onFilesSelected"
                              />
                              <v-card
                                class="d-flex flex-wrap mx-auto pa-2"
                                flat
                                max-width="700"
                              >
                                <div
                                v-for="(item, i) in filesPreview"
                                :key="`filesPreview-${i}`"
                                class="pa-0 text-center d-flex justify-space-between flex-column"
                                style="max-width: 130px; width: 130px"
                              >
                                <v-card
                                  class="d-flex flex-column justify-center align-center pt-2 pb-1 px-1"
                                  elevation="2"
                                  style="position: relative; border-radius: 12px;"
                                >
                                  <div
                                    v-if="!upLoading && (!item.status || !item.color)"
                                    style="position: absolute; top: 3px; right: 6px; z-index: 5;"
                                  >
                                    <v-btn
                                      icon
                                      small
                                      color="error"
                                      class="white elevation-2"
                                      @click.stop.prevent="removeFileFromUpload(i)"
                                    >
                                      <v-icon small>mdi-delete</v-icon>
                                    </v-btn>
                                  </div>
                                  <div style="position: relative; width: 100%; height: 100%;" class="d-flex justify-center align-center">
                                    
                                    <v-img
                                      v-if="item.url"
                                      :src="item.url"
                                      :aspect-ratio="1"
                                      class="rounded-lg mx-auto"
                                      max-width="80"
                                      max-height="80"
                                      contain
                                    ></v-img>
                                    
                                    <v-icon v-else size="64" color="red darken-1">
                                      mdi-file-pdf-box
                                    </v-icon>

                                    <div
                                      v-if="upLoading && item.status === 'loading'"
                                      class="d-flex justify-center align-center fill-height rounded-lg"
                                      style="position: absolute; inset: 0; background: rgba(0, 0, 0, 0.5); z-index: 2;"
                                    >
                                      <v-progress-circular
                                        color="white"
                                        indeterminate
                                        size="40"
                                        width="5"
                                      />
                                    </div>

                                    <v-card
                                      v-else-if="!!item.color"
                                      class="d-flex align-center justify-center rounded-lg"
                                      color="rgba(0, 0, 0, .5)"
                                      flat
                                      style="position: absolute; inset: 0; z-index: 2;"
                                    >
                                      <v-avatar :color="item.color">
                                        <v-icon>
                                          mdi-{{ !!item.status ? "check" : "close" }}
                                        </v-icon>
                                      </v-avatar>
                                    </v-card>

                                  </div>
                                  
                                  <span class="mt-2 text-truncate w-100" style="font-size: 12px; direction: ltr;" :title="item.name">
                                    {{ item.name }}
                                  </span>
                                </v-card>
                              </div>

                              </v-card>
                            </slot>

                            <v-card-text>
                              <slot
                                name="extension"
                                v-bind="{
                                  cats: computedCats,
                                  def: defaultCatName,
                                }"
                              >
                                <cat-to-upload
                                  v-if="showCatUpload"
                                  v-model="categoryName"
                                  :items="computedCats"
                                  :loading="upLoading"
                                  @action="uploadFiles"
                                  @clear="clearUpload"
                                />
                              </slot>
                            </v-card-text>
                          </v-card>
                        </div>
                      </template>
                    </custom-tabs>
                  </v-card>
                </custom-popup>

                <custom-popup
                  v-model="previewDialog"
                  :cons="{ title: $t('pdf_gallery.image_gallery') }"
                  max-width="500"
                  id="gallery"
                >
                  <template v-slot:helpinfo>
                    <help-info
                      :element-name="`${serviceName}-${componentName}-tab-gallery-photo`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      :label="$t('pdf_gallery.image_gallery')"
                    />
                  </template>

                  <v-card>
                    <v-tabs color="deep-purple accent-4" light>
                      <v-tab>{{ $t('pdf_gallery.all') }}</v-tab>
                      <v-tab-item>
                        <v-container fluid>
                          <v-row class="p-3">
                            <v-col
                              v-for="image in file"
                              :key="image.id"
                              cols="12"
                              class="p-0"
                              md="4"
                              :data-img="image.id"
                              @click.stop.prevent="selectedImage.url = image.full_path"
                            >
                              <v-img :src="image.full_path" :key="image.id" />
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-tab-item>
                      <v-tab
                        v-for="(category, indeximg) in imageCats"
                        :key="indeximg"
                        >{{ category }}</v-tab
                      >
                      <v-tab-item
                        v-for="item in imageCats"
                        :key="item"
                        :data-id="item"
                      >
                        <v-container fluid>
                          <v-row class="p-3">
                            <v-col
                              v-for="image in file.filter(
                                (img) => img.category === item,
                              )"
                              :key="image.id"
                              cols="12"
                              class="p-0"
                              md="4"
                              :data-img="image.id"
                              @click.stop.prevent="selectedImage.url = image.full_path"
                            >
                              <v-img :src="image.full_path" :key="image.id" />
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-tab-item>
                    </v-tabs>
                  </v-card>
                </custom-popup>

                <custom-popup
                  v-model="editDialog"
                  :cons="{ title: $t('pdf_gallery.edit_pdf') }"
                  max-width="600"
                  id="gallery"
                >
                  <template v-slot:helpinfo>
                    <help-info
                      :element-name="`${serviceName}-${componentName}-edit-pdf`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      :label="$t('pdf_gallery.edit_pdf')"
                    />
                  </template>

                  <v-card class="p-8">
                    <div class="rowinfo" style="width: 100%">
                      <v-text-field
                        hide-details
                        :label="$t('pdf_gallery.title')"
                        v-model="selectedImage.title"
                        dense
                        outlined
                        class="my-2 contentinfo"
                      /><help-info
                        :element-name="`${serviceName}-${componentName}-selectedImage-title`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        :label="$t('pdf_gallery.title')"
                      />
                    </div>
                    <div class="rowinfo" style="width: 100%">
                      <pic-selector style="width: 100%"
                        :edit-name="false"
                        :field.sync="selectedImage.url"
                        one-pic
                        single
                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-selectedImage-url`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        :label="$t('pdf_gallery.preview')"
                      />
                    </div>
                    <div class="contnetinfo">
                      <v-textarea
                        maxLength="250"
                        hide-details
                        :label="$t('pdf_gallery.description')"
                        rows="5"
                        v-model="selectedImage.description"
                        dense
                        outlined
                        class="my-2 contentinfo"
                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-selectedImage-description`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        :label="$t('pdf_gallery.description')"
                      />
                    </div>
                  </v-card>
                </custom-popup>

                <v-row no-gutters>
                  <v-col
                    v-for="(image, index) in salon.images"
                    :key="index"
                    cols="12"
                    class="p-2"
                  >
                    <div class="border rounded d-flex align-center px-2">
                      <div class="d-flex flex-column">
                        <v-btn
                          icon
                          small
                          @click.stop.prevent="moveUp(salon, image)"
                          :disabled="salon.images.indexOf(image) === 0"
                        >
                          <v-icon>mdi-chevron-up</v-icon>
                        </v-btn>

                        <v-btn
                          icon
                          small
                          @click.stop.prevent="moveDown(salon, image)"
                          :disabled="
                            salon.images.indexOf(image) ===
                            salon.images.length - 1
                          "
                        >
                          <v-icon>mdi-chevron-down</v-icon>
                        </v-btn>
                      </div>
                      <div class="mx-auto text-center">
                        <v-img
                          @click.stop.prevent="selectImage(image)"
                          :src="image.url"
                          contain
                          max-width="32"
                          max-height="32"
                          class="file-icon-small"
                        />
                      </div>
                      <v-btn
                        icon
                        color="red"
                        @click.stop.prevent="deleteSelectedImage(salon, image)"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-card-actions class="px-2 pt-6">
          <div class="rowinfo" style="width: 100% !important">
            <v-btn
              outlined
              color="success"
              @click.Stop.prevent="addGallery"
              class="contnetinfo"
              style="flex: 1 1 auto !important"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
            <help-info
              :element-name="`${serviceName}-${componentName}-addGallery`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('pdf_gallery.add_pdf_gallery')"
            />
          </div>
        </v-card-actions>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
import { ir } from "../../../check_domain_ir";
import CatToUpload from "../UploadCenter/catToUpload.vue";
import { rbAxios } from "@/main";
import detectFileUploading_file from "./detectFileUploading_file.vue";
import PdfFileCard from "./PdfFileCard.vue";
import picSelector from "../UploadCenter/picSelector.vue";

export default {
  name: "PdfGallery",
  components: {
    CatToUpload,
    detectFileUploading_file,
    PdfFileCard,
    picSelector,
  },
  props: {
    editImg: {
      type: Array,
      default: () => [],
    },
    is_edit: {
      type: Boolean,
      default: false,
    },
    count: {
      type: Number,
      default: 10,
    },
    data: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      activeGalleryIndex: 0,
      defaultCatName: "",
      tabs: 1,
      filesModel: null,
      upLoading: false,
      loading: false,
      filesPreview: [],
      categoryName: "",

      defLoading: false,
      // layoutOptions: [
      //   { text: "نمایش به صورت لیست", value: "list" },
      //   { text: "نمایش آکاردئونی", value: "accordion" },
      //   { text: "نمایش به صورت اسلایدر", value: "slider" },
      // ],
      helpData: [],
      serviceName: "Qrland",
      componentName: "pdf-gallery",
      dialog: false,
      manualDialog: false,
      editDialog: false,
      previewDialog: false,
      file: [],
      imageCats: [],
      fileCats: [],
      url: process.env.VUE_APP_ROBOT,
      manualImage: {
        title: "",
        url: "",
        description: "",
        link: "",
      },
      gallery: [
        {
          name: "گالری",
          images: [],
        },
      ],
      selectedImage: {},
      editGaleryName: -1,
    };
  },
  computed: {
    layoutOptions() {
      return [
        { text: this.$t("pdf_gallery.layout.list"), value: "list" },
        { text: this.$t("pdf_gallery.layout.accordion"), value: "accordion" },
        { text: this.$t("pdf_gallery.layout.slider"), value: "slider" },
      ];
    },
    tabItems() {
      return [
        {
          id: 0,
          text: this.$t("pdf_gallery.tabs.add_file"),
          icon: "mdi-cloud-upload-outline",
          value: "add-image",
        },
        {
          id: 1,
          text: this.$t("pdf_gallery.tabs.pdf_gallery"),
          icon: "mdi-image-area-close",
          value: "gallery-image",
        },
        {
          id: 2,
          text: this.$t("pdf_gallery.tabs.link"),
          icon: "mdi-link-plus",
          value: "link-image",
        },
      ];
    },
    allFiles() {
      let files = [];
      if (this.pdfData && this.pdfData.length > 0) {
        this.pdfData.forEach((category) => {
          if (category.images && category.images.length > 0) {
            // فقط فایل‌های مجاز
            const validImages = category.images.filter((i) => {
              const ext = i.link.split(".").pop().toLowerCase();
              return ["pdf", "txt"].includes(ext);
            });
            files = files.concat(validImages);
          }
        });
      }
      return files;
    },
    computedCats() {
      if (
        !!this.file.categories?.length &&
        !this.file.categories.includes(this.defaultCatName)
      ) {
        let arr = [];
        arr.push(this.defaultCatName);
        return [...arr, ...this.file.categories];
      }

      return this.file.categories;
    },
    showCatUpload() {
      return (
        !this.$slots.extension &&
        !!this.filesModel &&
        typeof this.filesModel === "object" &&
        !!this.filesModel.length
      );
    },
    rules() {
      return {
        link: (v) => !v || this.isLink(v) || this.$t("enter_valid_link"),
      };
    },
  },
  watch: {
    dialog(val) {
      if (val) {
        this.getError = this.getDefError = false;
      }
    },
    tabs(val) {
      if (
        val === 1 &&
        (!this.file.items || !this.file.items.data) &&
        !this.loading
      ) {
        this.getFiles();
      }
    },

    file() {
      const categories = [];

      this.file.forEach((item) => {
        if (item.category) categories.push(item.category);
      });

      this.fileCats = [...new Set(categories)];
    },
    gallery: {
      deep: true,
      handler(value) {
        this.data["pdf"] = value;
      },
    },
  },
  methods: {
    clearUpload() {
      this.filesModel = null;
      this.filesPreview = [];
      this.categoryName = "";
    },
    moveGalleryUp(i) {
      const temp = this.gallery[i - 1];
      this.gallery[i - 1] = this.gallery[i];
      this.gallery[i] = temp;
      this.gallery = [...this.gallery];
      this.data["pdf"] = [...this.gallery];
    },
    moveGalleryDown(i) {
      const temp = this.gallery[i + 1];
      this.gallery[i + 1] = this.gallery[i];
      this.gallery[i] = temp;
      this.gallery = [...this.gallery];
      this.data["pdf"] = [...this.gallery];
    },
    onFilesSelected(obj) {
      if (!obj || !obj.files) return;

      this.filesModel = obj.files;

      obj.files.forEach((file) => {
        this.filesPreview.push({
          url: file.url || this.getFileIcon(file.name),
          name: file.name,
        });
      });
    },

    async uploadFiles(name = this.categoryName) {
      for (const file of this.filesModel) {
        await this.uploadToServer(file, name);
      }
    },
    getFileIcon(path) {
      if (!path) return "media/file.svg";
      const ext = path?.split(".").pop().toLowerCase();
      switch (ext) {
        case "doc":
        case "docx":
          return `media/doc.webp`;
        case "pdf":
          return `media/pdf.webp`;
        case "txt":
          return `media/txt.webp`;
        default:
          return "media/file.svg";
      }
    },
    handleFileUpload(event) {
      let arr = Array.from(event || []);
      const allowedExtensions = ["pdf", "txt"];

      if (!!arr && !!arr.length) {
        for (const file of arr) {
          const fileExtension = file.name.split(".").pop().toLowerCase();

          if (allowedExtensions.includes(fileExtension)) {
            if (file.size > 10000000) {
              let index = this.filesModel.findIndex((f) => f.name === file.name);
              if (index > -1) this.filesModel.splice(index, 1);
              this.$toast.error(this.$t('pdf_gallery.messages.file_too_large'));
              return;
            }

            this.filesPreview.push({
              url: file.url || this.getFileIcon(file.name),
              name: file.name,
            });
          } else {
            let index = this.filesModel.findIndex((f) => f.name === file.name);
            if (index > -1) this.filesModel.splice(index, 1);
            this.$toast.error(this.$t('pdf_gallery.messages.invalid_file_type'));
          }
        }
      }
      this.$forceUpdate();
    },

    dragEvent(e) {
      e.stopPropagation();
      e.preventDefault();

      let uploader = this.$refs.uploader;
      if (!uploader) return;

      let el = uploader.$el || uploader;

      if (e.type === "dragover" && !el.classList.contains("drag-over")) {
        el.classList.add("drag-over");
      } else if (e.type === "dragleave" && el.classList.contains("drag-over")) {
        el.classList.remove("drag-over");
      } else if (e.type === "drop") {
        el.classList.remove("drag-over");
        const files = e.target.files || e.dataTransfer.files;
        let arr = [];
        for (const file of files) {
          arr.push(file);
        }
        this.filesModel = arr;
        this.handleFileUpload(files);
      } else if (e.type === "click") {
        const fileInputEl =
          this.$refs.fileInput.$el.querySelector('input[type="file"]');
        if (fileInputEl) {
          fileInputEl.click();
        }
      }
    },

    removeFileFromUpload(index) {
      this.filesModel.splice(index, 1);
      this.filesPreview.splice(index, 1);
    },
    async uploadToServer(file, name) {
      const formData = new FormData();
      this.upLoading = true;

      const index = this.filesModel.indexOf(file);

      let cat = typeof name === "string" ? name : this.categoryName;

      formData.append("file", file);
      formData.append("category", cat);
      formData.append("type", "other");
      formData.append("file_type", "file");

      try {
        this.filesPreview[index].status = "loading";

        await rbAxios
          .post("/files", formData)
          .then((response) => {
            this.filesPreview[index].status = true;
            this.filesPreview[index].color = "success";

            if (
              !!this.filesModel.length &&
              index + 1 >= this.filesModel.length
            ) {
              this.filesModel = null;
              this.filesPreview = [];
              this.$toast.success(this.$t("uploaded_successfully"));
              this.gotoSaved(cat);
            }
          })
          .catch((error) => {
            this.filesPreview[index].status = false;
            this.filesPreview[index].color = "error";
            this.$toast.error(this.$t('pdf_gallery.messages.upload_error'));
          });
      } catch (e) {
        console.log(e);
      }

      this.upLoading = false;
    },
    gotoSaved(cat) {
      this.tabs = 1;
      this.getFiles();
    },
    select(salon, image) {
      const isSelected = salon.images.some((i) => i.link === image.full_path);

      if (!isSelected) {
        const allowed = ["pdf", "txt"];
        const ext = image.full_path.split(".").pop().toLowerCase();
        if (!allowed.includes(ext)) {
          this.$toast.error(this.$t('pdf_gallery.messages.only_pdf_txt_allowed'));
          return;
        }

        salon.images.push({
          title: image.title,
          link: image.full_path,
          url: image.url,
          description: "",
          selected: true,
        });
        image.selected = true;
      } else {
        salon.images = salon.images.filter((i) => i.link !== image.full_path);
        image.selected = false;
      }

      salon.images = [...salon.images];
      this.data.pdf = [...this.gallery];
    },

    getFiles() {
      let Token = localStorage.getItem("id_token");
      const vm = this;
      const url_local = ir(this.url);

      $.ajax({
        url: `${url_local}/files`,
        headers: {
          ACCEPT: "application/json",
          Authorization: Token,
        },
        data: { file_type: "file" },
        type: "GET",
        success(data) {
          vm.file = data.data.map((f) => {
            const selectedInThisGallery = vm.gallery[
              vm.activeGalleryIndex
            ]?.images.some((img) => img.link === f.full_path);

            const ext = f.full_path ? f.full_path.split(".").pop().toLowerCase() : "";
            let fileUrl = f.url;
            if (ext === "pdf" && f.full_path_image) {
              fileUrl = f.full_path_image;
            } else {
              fileUrl = vm.getFileIcon(f.full_path || f.path);
            }

            return { ...f, selected: selectedInThisGallery, url: fileUrl };
          });
        },
      });
    },

    moveUp(salon, image) {
      let imageIndex = salon.images.indexOf(image);
      let previousIndex = imageIndex - 1;
      let tempPreviousImage = { ...salon.images[previousIndex] };
      let tempCurrentImage = { ...image };

      salon.images[imageIndex] = tempPreviousImage;
      salon.images[previousIndex] = tempCurrentImage;

      this.$forceUpdate();
      salon.images = [...salon.images];
      this.data["pdf"] = [...this.gallery];
    },
    moveDown(salon, image) {
      let imageIndex = salon.images.indexOf(image);
      let nextIndex = imageIndex + 1;
      let tempPreviousImage = { ...salon.images[nextIndex] };
      let tempCurrentImage = { ...image };

      salon.images[imageIndex] = tempPreviousImage;
      salon.images[nextIndex] = tempCurrentImage;

      this.$forceUpdate();

      salon.images = [...salon.images];
      this.data["pdf"] = [...this.gallery];
    },
    addGallery() {
      this.gallery.push({
        name: this.$t('pdf_gallery.gallery_prefix') + " " + (this.gallery.length + 1),
        images: [],
      });
    },
    deleteSelectedImage(salon, image) {
      salon.images.splice(salon.images.indexOf(image), 1);
    },
    addImageManual(salon) {
      if (!this.manualImage.title || !this.manualImage.link) {
        this.$toast.error(this.$t('pdf_gallery.messages.title_url_required'));
        return;
      }

      const newImage = {
        title: this.manualImage.title,
        link: this.manualImage.link,
        description: this.manualImage.description,
        url: this.manualImage.url || this.getFileIcon(this.manualImage.link),
      };
      salon.images.push(newImage);

      this.manualDialog = false;

      this.manualImage = {
        title: "",
        url: "",
        description: "",
        link: "",
      };
    },
    selectImage(image) {
      this.selectedImage = image;
      this.editDialog = true;
    },
  },
  mounted() {
    this.getFiles();
    if (this.data && this.data.pdfSelector && !this.data.pdfSelector.layout) {
      this.$set(this.data.pdfSelector, "layout", "list");
    }

    if (this.data?.pdf) this.gallery = this.data.pdf;
  },
};
</script>

<style scoped>
.v-tabs >>> .v-tabs-slider-wrapper {
  display: block !important;
}

@media screen and (max-width: 600px) {
  .v-tabs >>> .v-slide-group__prev {
    display: none !important;
  }
}

#uploader {
  transition: all 0.3s ease;
  background-color: rgba(0, 0, 0, 0.2);
  border: 2px dashed #797979 !important;
}

.drag-over {
  border: 2px dashed #fff !important;
  background-color: rgba(33, 150, 243, 0.33) !important;
}

@media screen and (max-width: 600px) {
  .v-card >>> .v-expansion-panel-content__wrap {
    padding: 0 !important;
  }
}
@media (max-width: 600px) {
  .file-icon-small {
    max-width: 48px !important;
    max-height: 48px !important;
  }
}
.file-card {
  padding: 16px 8px;
  border-radius: 12px;
  position: relative;
  cursor: pointer;
  transition: all 0.25s ease;
  border: 2px solid transparent;
}

.file-card.selected {
  border-color: #1abc9c !important;
  box-shadow: 0 0 12px rgba(26, 188, 156, 0.45) !important;
}

.checkbox-wrapper {
  position: absolute;
  top: 6px;
  left: 6px;
  background: white;
  border-radius: 50%;
  padding: 3px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.15);
  z-index: 10;
}

.file-title {
  display: block;
  margin-top: 8px;
  font-weight: bold;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  text-align: center;
}
</style>
